export default __webpack_public_path__ + "static/media/basic.8faef389.png";